export const isEqualToZero = num => (Number(num) || 0) === 0;

export const getRegistrationBonusesData = (bonusPlanId, intl) => {
  const data = intl.formatMessage({ id: `registration.bonus.${bonusPlanId}` });
  let parsedData = null;

  if (data) {
    try {
      parsedData = JSON.parse(data);
    } catch (e) {
      console.log('Incorrect data provided for the registration bonus. Check-up the translations file.');
    }
  }

  return parsedData;
};

export const formatRegistrationDate = (registrationDate = '') => {
  const [d, month, y, h, m, s] = registrationDate.split(/-| |:/);

  return new Date(`${month}/${d}/${y} ${h}:${m}:${s} UTC`);
};

export const enrichRegistrationBonuses = (bonuses, intl, regDate, idAccessor = 'value') => (bonuses || []).reduce((acc, item) => {
  const registrationExtendedExpiryDate = formatRegistrationDate(regDate);
  const bonusData = getRegistrationBonusesData(item[idAccessor], intl);

  if (bonusData?.endHours) {
    registrationExtendedExpiryDate.setHours(registrationExtendedExpiryDate.getHours() + bonusData?.endHours);

    return [...acc, {
      ...item,
      registrationExtendedExpiryDate,
      hasNoExpiry: bonusData?.hasNoExpiry,
    }];
  }

  return [...acc, item];
}, []);

export const getRegistrationBonuses = bonuses => bonuses.filter(
  bonus => bonus.registrationExtendedExpiryDate
);

export const findActiveRegistrationBonus = bonuses => bonuses.reduce(
  (a, b) => a.registrationExtendedExpiryDate < b.registrationExtendedExpiryDate ? a : b,
  []
);

export const filterOutFutureBonuses = (bonuses) => {
  const activeBonus = findActiveRegistrationBonus(getRegistrationBonuses(bonuses));

  return bonuses.filter(
    bonus => !bonus.registrationExtendedExpiryDate
      || bonus.registrationExtendedExpiryDate === activeBonus.registrationExtendedExpiryDate
  );
};

export const filterOutExpiredBonuses = bonuses => bonuses.filter(({ registrationExtendedExpiryDate, hasNoExpiry }) => {
  const now = new Date();

  return hasNoExpiry || !registrationExtendedExpiryDate || registrationExtendedExpiryDate > now;
});
